import config from "../../configuration";

const buildApiUrl = (path: string): string => {
    return new URL(path, config.giggedApiBaseUrl).href;
};

export default buildApiUrl;